<template>
    <v-card
            class="mx-auto"
            max-width="500"
    >

        <v-alert
                v-if="alert.show"
                :type="alert.type"
                border="left"
        >
            {{alert.text}}
        </v-alert>

        <v-card-title class="title font-weight-regular justify-space-between">
            <span>{{ currentTitle }}</span>

            <v-progress-linear
                    :active="loading"
                    indeterminate
                    rounded
            ></v-progress-linear>

        </v-card-title>

        <v-window v-model="step">
            <v-window-item :value="1">
                <v-card-text>
                    <div class="text-body-1 mt-0 pt-0 mb-2">{{form.email}}</div>
                    <span class="caption grey--text text--darken-1">
                    Este é o email que deverá ser usado para logar no digitab
                  </span>
                </v-card-text>
            </v-window-item>

            <v-window-item :value="2">
                <v-card-text>
                    <v-text-field
                            v-model="form.pwd"
                            label="Senha"
                            type="password"
                    ></v-text-field>
                    <v-text-field
                            v-model="form.pwdConfirm"
                            label="Confirme a senha"
                            type="password"
                            :error-messages="pwdCheckMsgError"
                    ></v-text-field>
                    <span class="caption grey--text text--darken-1">
            Por favor, digite uma senha para sua conta
          </span>
                </v-card-text>
            </v-window-item>

            <v-window-item :value="3">
                <div
                        v-if="alert.type == 'success'"
                        class="pa-4 text-center"
                >
                    <h3 class="title font-weight-light mb-2">Bem vindo(a) ao digitab</h3>
                    <span class="caption grey--text">Obrigado por nos escolher!</span>
                </div>
                <div v-else-if="alert.type == ''" class="pa-4 text-center">
                    <h3 class="title font-weight-light mb-2">Ativando a conta</h3>
                </div>
            </v-window-item>
        </v-window>

        <v-divider></v-divider>

        <v-card-actions>
            <v-btn
                    v-if="alert.type != 'success'"
                    :disabled="step === 1"
                    text
                    @click="step--"
            >
                Voltar
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
                    v-if="alert.type != 'success'"
                    :disabled="btnNextDisable"
                    color="primary"
                    depressed
                    @click="step++"
            >
                Continuar
            </v-btn>

            <v-btn
                    v-if="alert.type == 'success'"
                    color="primary"
                    depressed
                    href="/user/login"
            >
                Fazer login
            </v-btn>

        </v-card-actions>
    </v-card>
</template>


<script>
    export default {
        data: () => ({
            form: {
                email: '',
                pwd: '',
                pwdConfirm: '',
                token: ''
            },
            step: 1,
            pwdCheckMsgError: '',
            btnNextDisable: false,

            alert: {
                type: '',
                show: '',
                text: '',
            },
            loading: false,
        }),

        created() {
            this.form.email = this.$route.query.email;
            this.form.token = this.$route.query.token;
        },

        watch: {
            'form.pwdConfirm': {
                handler() {
                    this.pwdCheckMsgError = '';
                    this.btnNextDisable = false;

                    if (this.form.pwd != this.form.pwdConfirm) {
                        this.btnNextDisable = true;
                        this.pwdCheckMsgError = 'As senhas digitadas devem ser iguais';
                    }
                }
            },

            step: {
                handler() {
                    this.btnNextDisable = false;

                    if (this.step === 2 && this.form.pwdConfirm === '') {
                        this.btnNextDisable = true;
                    }

                    if (this.step === 3) {
                        this.btnNextDisable = true;
                    }

                    if (this.step === 3) {
                        this.activate();
                    }
                }
            }

        },

        computed: {
            currentTitle() {
                switch (this.step) {
                    case 1:
                        return 'Ativação de conta'
                    case 2:
                        return 'Crie uma senha'
                    default:
                        return ''
                }
            },
        },

        methods: {
            activate() {
                this.loading = true;

                axios.patch('/usuarios/activate',
                    this.form
                ).then((response) => {
                    this.alert.type = 'success';
                    this.alert.show = true;
                    this.alert.text = 'Conta ativada';
                    this.codAtivacao = response.data.codigo_ativacao;
                }, (error) => {
                    this.alert.type = 'warning';
                    this.alert.show = true;
                    this.alert.text = error.response.data.msg || 'Tivemos um problema ao ativar a conta';
                }).catch(error => {
                    console.log(error)
                    this.alert.type = 'error';
                    this.alert.show = true;
                    this.alert.text = 'Houve algum erro ao ativar a conta.';
                }).finally(() => {
                    this.loading = false;
                });
            }

        }
    }
</script>
